import { modProfileUid } from "@/context/utils";
import mixpanel from "mixpanel-browser";
let token = process.env.NEXT_PUBLIC_MIX_PANEL_TOKEN;
let actions;
if (token) {
  mixpanel.init(token, {
    opt_out_tracking_by_default: false,
    opt_out_persistence_by_default: false,
  });
  actions = {
    track: (name: string, props: any, uid: string | undefined) => {
      if (window.Android) {
        if (uid) {
          const modNumber = mixpanelModMap[name];
          const allowTrack = modProfileUid(uid, modNumber);
          if (allowTrack) {
            window.Android.trackEvent(name, JSON.stringify(props));
          }
        }
      } else {
        if (uid) {
          const modNumber = mixpanelModMap[name];
          const allowTrack = modProfileUid(uid, modNumber);
          if (allowTrack) {
            mixpanel.track(name, props, (callback) => {
              console.log(callback);
            });
          }
        }
      }
    },
    identify: (id: string) => {
      mixpanel.identify(id);
    },
    people: {
      set: (props: any, id: string) => {
        if (window.Android) {
          window.Android.setPeople(JSON.stringify(props), id);
        }
      },
      update: (props: any, id?: string) => {
        if (window.Android) {
          window.Android.setPeople(JSON.stringify(props), id);
        }
      },
      delete: () => {
        if (window.Android) {
          window.Android.deletePeople();
        } else {
          mixpanel.people.delete_user();
        }
      },
    },
  };
}

const mixpanelModMap: Record<string, number> = {
  "App opened": 100,
  "Story Viewed": 100,
  "Trait Viewed": 100,
  "Results Snippet Viewed": 100,
  "Peer Story Viewed": 100,
  "Dimension Summary Viewed": 100,
  "Notification Opened": 100,
  "Screenshot taken": 100,
  "Compatibility Snippet Viewed": 100,
  "Daily Insight Viewed": 100,
  "Weekly Chart Viewed": 100,
  "Assessment loaded": 100,
  "Assessment completed": 100,
  "Daily Story Viewed": 100,
  "Element Discovered": 100,
  "Feed Item Clicked": 10,
  "Post viewed": 10,
  "Comment modal summoned": 10,
  "Poll Viewed": 10,
  "Error Modal Summoned": 10,
  "Quiz started": 10,
  "Generate CTA Clicked": 10,
  "Feedback given": 1,
  "Quiz completed": 10,
  "Post liked": 10,
  "Poll Breakdown Selected": 10,
  "User message sent": 1,
  "Post to connections CTA pressed": 10,
  "Onboarding - First Element Discovery Sequence Viewed": 1,
  "Archetype Discovered": 10,
  "Poll Responded": 10,
  "Friend request sent": 1,
  "Comment voted": 10,
  "Quiz Breakdown Viewed": 10,
  "Post created": 10,
  "Friend request accepted": 1,
  "User authenticated": 1,
  "Unauthenticated profile viewed": 1,
  "User logged out": 10,
  "Global search opened": 10,
  "Premium Conversion Modal Summoned": 1,
  "Username set": 1,
  "Nature Discovered": 1,
  "Community question viewed": 10,
  "Dimension reset": 1,
  "Comment created": 10,
  "Pattern Discovered": 10,
  "App Feedback Prompt Seen": 1,
  "Message sent": 10,
  "Phone number verified": 1,
  "Chatroom listings viewed": 10,
  "Demographics collected": 1,
  "System Share Modal Executed": 1,
  "System Share Modal Summoned": 1,
  "Profile Completion Screen Interacted": 1,
  "Content copied": 10,
  "Chatroom opened": 10,
  "Shared to Social": 1,
  "Notification Level Manually Set": 10,
  "Signup credit given": 1,
  "App Feedback Submitted": 1,
  "Go deeper initial message selected": 1,
  "Dimensional Assistant Information Modal Summoned": 1,
  "Sign Up Credit Step Viewed": 1,
  "Public Profile Permission Set": 10,
  "Address book access granted": 1,
  "Report viewed": 1,
  "Go deeper CTA pressed": 1,
  "Retry CTA Clicked": 1,
  "Gating Modal Summoned": 1,
  "Age Collected": 1,
  "Gender Collected": 1,
  "Nudge Sent": 1,
  "Onboarding - Invite Friends Step Interacted": 1,
  "Profile social link clicked": 1,
  "Enable notification cta clicked": 1,
  "Get more messages CTA pressed": 1,
  "Purchase CTA clicked": 1,
  "App/Play Store link clicked from homepage": 1,
  "Web profile link clicked": 1,
  "View full profile CTA clicked": 1,
  "Regenerate CTA Clicked": 1,
  "Account Deleted": 1,
  "Chatbot | Assistant message feedback given": 1,
  "Chatbot | Notify me CTA clicked": 1,
  "Social Link Added To Profile": 1,
  "BetterHelp | Get started CTA pressed": 1,
  "Personality Analysis Feedback Given": 1,
  "Chatbot | Assistant message regenerate CTA clicked": 1,
  "Chatbot | Conversation limit reached": 1,
  "Comment deleted": 1,
  "Premium Purchased": 1,
  "Consumable purchased": 1,
  "BetterHelp | Partnership details CTA pressed": 1,
  "Chatbot | Conversation reset CTA clicked": 1,
  "Profile / ambassador check clicked": 1,
  "Full Tracked Dimension Breakdown Viewed": 1,
  "Update Content CTA Pressed": 1,
  "Full Tracked Trait Breakdown Viewed": 1,
  "INNI download CTA pressed": 1
};

export const Mixpanel = actions;
